<template>
    <svg aria-hidden="true" width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="10" y="14" width="10" height="14" rx="0.638889" transform="rotate(-180 10 14)" fill="#F2994B" />
        <rect x="17.3058" y="14.1341" width="10" height="10" rx="0.638889" transform="rotate(-136.935 17.3058 14.1341)" fill="#FFD3A8" />
    </svg>
</template>
